// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// export const environment = {
//   production: true,
//   tinyMCEKey: 'kku6o3vy72uqca8s9sj8ppo9k9gc2r9dlca09yn9t5ej4v9h',  
//   apiUrl: 'https://shop-api.uscultrasound.com/api/',
//   stripeApiKey : 'pk_live_51IRkseBV52QOtawiwrZ5xPqWF9vTFH81DpVCx1HT1krqYQzpL6gAr1tAIsbaQ1jGRP2AYBvoCpmUVHPsH8QqVizE00lgCnZUq8',
//   stripeReturnUrl: 'https://shop.uscultrasound.com/#/payment-status'
// };

// export const environment = {
//   production: false,
//   tinyMCEKey: 'kku6o3vy72uqca8s9sj8ppo9k9gc2r9dlca09yn9t5ej4v9h',    
//   apiUrl: 'http://localhost:50002/api/',
//   stripeApiKey : 'pk_test_51IRkseBV52QOtawiMz5PMh7SSquWNiMzhdo5BBAEMWOlW5rbcHnfNK8V9yJghGCBgW2NHpa399UdBWgpoJP9a9qF00JzaZI6dQ',
//   stripeReturnUrl: 'http://localhost:4200/#/payment-status'
// };

export const environment = {
  production: false,
  tinyMCEKey: 'kku6o3vy72uqca8s9sj8ppo9k9gc2r9dlca09yn9t5ej4v9h',
  apiUrl: 'https://uscapi.dipoletechi.com/api/',
  stripeApiKey: 'pk_test_51IRkseBV52QOtawiMz5PMh7SSquWNiMzhdo5BBAEMWOlW5rbcHnfNK8V9yJghGCBgW2NHpa399UdBWgpoJP9a9qF00JzaZI6dQ',
  stripeReturnUrl: 'https://uscshop.dipoletechi.com/#/payment-status'
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
